import type { ComponentType } from 'react';

/**
 * Retry d'un import dynamique jusqu'à 3 fois — gère les hash de chunks
 * périmés après un déploiement (Failed to fetch dynamically imported module).
 */
export function lazyRetry<T extends { default: ComponentType<never> }>(
  factory: () => Promise<T>,
  retries = 3,
  interval = 1000,
): Promise<T> {
  return new Promise((resolve, reject) => {
    factory()
      .then(resolve)
      .catch((error: Error) => {
        if (retries <= 0) {
          reject(error);
          return;
        }
        // Only retry for chunk load failures
        if (
          error.message?.includes('Failed to fetch dynamically imported module') ||
          error.message?.includes('Loading chunk') ||
          error.message?.includes('Loading CSS chunk')
        ) {
          setTimeout(() => {
            lazyRetry(factory, retries - 1, interval).then(resolve, reject);
          }, interval);
        } else {
          reject(error);
        }
      });
  });
}
